import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MediaModule } from '../media/index';

import { CardBodyComponent } from './components/body/body.component';
import { CardColumnsComponent } from './components/columns/columns.component';
import { CardComponent } from './card.component';
import { CardContentComponent } from './components/content/content.component';
import { CardDeckComponent } from './components/deck/deck.component';
import { CardFooterComponent } from './components/footer/footer.component';
import { CardGroupComponent } from './components/group/group.component';
import { CardHeaderComponent, CardHeadingHeaderComponent } from './components/header/header.component';
import { CardSubtitleComponent, CardHeadingSubtitleComponent } from './components/subtitle/subtitle.component';
import { CardTitleComponent, CardHeadingTitleComponent } from './components/title/title.component';

export { CardBodyComponent } from './components/body/body.component';
export { CardColumnsComponent } from './components/columns/columns.component';
export { CardComponent } from './card.component';
export { CardContentComponent } from './components/content/content.component';
export { CardDeckComponent } from './components/deck/deck.component';
export { CardFooterComponent } from './components/footer/footer.component';
export { CardGroupComponent } from './components/group/group.component';
export { CardHeaderComponent, CardHeadingHeaderComponent } from './components/header/header.component';
export { CardSubtitleComponent, CardHeadingSubtitleComponent } from './components/subtitle/subtitle.component';
export { CardTitleComponent, CardHeadingTitleComponent } from './components/title/title.component';

@NgModule({
  declarations: [
    CardBodyComponent,
    CardColumnsComponent,
    CardComponent,
    CardContentComponent,
    CardDeckComponent,
    CardFooterComponent,
    CardGroupComponent,
    CardHeaderComponent,
    CardHeadingHeaderComponent,
    CardHeadingSubtitleComponent,
    CardHeadingTitleComponent,
    CardSubtitleComponent,
    CardTitleComponent,
  ],
  imports: [
    CommonModule,
    MediaModule
  ],
  exports: [
    CardBodyComponent,
    CardColumnsComponent,
    CardComponent,
    CardContentComponent,
    CardDeckComponent,
    CardFooterComponent,
    CardGroupComponent,
    CardHeaderComponent,
    CardHeadingHeaderComponent,
    CardHeadingSubtitleComponent,
    CardHeadingTitleComponent,
    CardSubtitleComponent,
    CardTitleComponent,
  ]
})
export class CardModule {}
